<template>
  <div class="header">
        <img class="logo-img" src="../../../images/logo.png"/>
        <div class="company-name">包庄科技有限公司</div>
  </div>
</template>

<script>
export default {
  name: 'header'
}
</script>
<style scoped>
.header{
    margin-top:2rem;
    margin-left: 2rem;
    display: flex;
    flex-direction: row;
    width: 22rem;
    height: 5rem;
    line-height: 5rem;
}
.logo-img{
    height: 5rem;
    width: 5rem;
}
.company-name{
    margin-left: 1rem;
    font-size: 1.5rem;
    color: #3EA4FD;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>
